<script lang="ts">
	import type { ClassValue, HTMLAttributes } from 'svelte/elements';
	import BaseButton from './baseButton.svelte';
	import type { ButtonSize } from './types';
	import { sizeClasses } from './utils';
	import type { Snippet } from 'svelte';

	type ButtonTheme =
		| 'light'
		| 'dark'
		| 'lime'
		| 'brown'
		| 'purple'
		| 'purple-2'
		| 'orange'
		| 'green'
		| 'dark-green';

	interface Props extends HTMLAttributes<HTMLButtonElement | HTMLAnchorElement> {
		theme?: ButtonTheme;
		size?: ButtonSize;
		disabled?: boolean;
		btn?: HTMLButtonElement | undefined;
		class?: ClassValue;
		wrapperClass?: string;
		href?: HTMLAnchorElement['href'];
		target?: HTMLAnchorElement['target'];
		rel?: HTMLAnchorElement['rel'];
		iconLeading?: Snippet;
		iconTrailing?: Snippet;
		children?: Snippet;
	}

	let {
		theme = 'light',
		size = 'large',
		disabled = false,
		btn,
		class: className,
		wrapperClass,
		href,
		target,
		rel,
		iconLeading,
		iconTrailing,
		children,
		...other
	}: Props = $props();

	const themeClasses: Record<ButtonTheme, string> = {
		light: 'text-stone-4 bg-green-3 disabled:bg-stone-1',
		dark: 'text-stone-4 bg-green-0',
		'dark-green': 'text-stone-4 bg-green-1 disabled:bg-stone-1',
		lime: 'text-green-0 bg-green-5',
		brown: 'text-stone-4 bg-brown-1',
		purple: 'text-stone-4 bg-purple-1',
		'purple-2': 'bg-stone-4 text-purple-1',
		orange: 'text-stone-4 bg-orange-1',
		green: 'text-stone-4 bg-green-2'
	};

	let themeClass = $derived(themeClasses[theme]);
	let sizeClass = $derived(sizeClasses[size]);
</script>

<BaseButton
	bind:btn
	{...other}
	{wrapperClass}
	{href}
	{target}
	{rel}
	{size}
	{disabled}
	class={[
		themeClass,
		sizeClass,
		'font-semibold',
		...(Array.isArray(className) ? className : [className])
	]}
	{iconLeading}
	{iconTrailing}
	{children}
></BaseButton>
